import { ClientRouteOptions, TypedClientAjaxProxy } from "@cervval.js/client-html5-spa/routes";
import { AuthInfosRoutes, LoginFormAuthRoutes } from "@cervval.js/common-auth/src/authRoutes";
import { LogService, LOG_SERVICE } from "@cervval.js/common/services";
import { Injectable } from "@cervval.js/common/src/dependencies/injectable";
import { Injected } from "@cervval.js/common/src/dependencies/injected";

export const LOGIN_CLIENT_MAIN_SERVICE = "LoginClientMainService";

@Injectable(LOGIN_CLIENT_MAIN_SERVICE)
export class LoginClientMainService {

    @Injected(LOG_SERVICE)
    public log!: LogService;

    @TypedClientAjaxProxy({ urlPrefix: "../" })
    public authInfosRoutes!: AuthInfosRoutes<ClientRouteOptions>;

    @TypedClientAjaxProxy({ urlPrefix: "../" })
    public loginRoutes!: LoginFormAuthRoutes<unknown, ClientRouteOptions>;

}